import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedComissaoData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`codigoParceiro/relatorio?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllComissaoData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`codigoParceiro/relatorio?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.empresa}"`,
    `"${data.documento}"`,
    `"${toDate(data.dataCadastro)}"`,
    `"${data.parceiro}"`,
    `"${data.renovacoes}"`,
    `"${data.tipoAssinatura}"`,
    data.pagamento ? 'Pago' : 'pendente',
  ]);
};
export const pagarComissao = async(idCodigo) => {
  const httpClient = authenticatedHttpClientFactory();
  try {
    await httpClient.put(`codigoParceiro/${idCodigo}`);
    return true;
  } catch (error) {
    return false;
  }
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCriacaoInicial: toDateFromPtBr(options.creationInitialDate),
  dataCriacaoFinal: toDateFromPtBr(options.creationEndDate),
});
